module.exports = __webpack_public_path__ + "img/Flag_of_New_Zealand.76bbb687.svg";